import { Component, Input, OnInit } from '@angular/core';
import { ConnectionObject } from '@bo-client/shared/models/connectionObject';
import { ConnectionObjectAdditionalInfoModel } from '@bo-client/activation-management/shared/models/connection-object-additional-info.model';

@Component({
  selector: 'app-connection-object-summary',
  templateUrl: './connection-object-summary.component.html',
  styleUrls: ['../../../../../../shared/summaries/css-summary.component.scss']
})
export class ConnectionObjectSummaryComponent implements OnInit {
  @Input() connectionObject: ConnectionObject;
  @Input() connectionObjectAdditionalInfo: ConnectionObjectAdditionalInfoModel;

  constructor() {}

  ngOnInit(): void {}
}
